<template>
  <div class="theme-search-area">
    <form @submit.prevent="search_car">
      <div class="theme-search-area-form">
        <div class="row" data-gutter="10">
          <div class="col-md-2-5" style="color:white">Local da retirada</div>
          <div class="col-md-2-5" style="color:white">Local da devolução</div>
          <div class="col-md-1-5" style="color:white">Data de retirada</div>
          <div class="col-md-1-5" style="color:white">Hora de retirada</div>
          <div class="col-md-1-5" style="color:white">Data de devolução</div>
          <div class="col-md-1-5" style="color:white">Hora de devolução</div>
          <div class="col-md-1"></div>
        </div>
        <div class="row" data-gutter="10">
          <div class="col-md-2-5">
            <div
              class="theme-search-area-section first theme-search-area-section-curved theme-search-area-section-fade-white"
            >
              <div class="theme-search-area-section-inner">
                <i class="theme-search-area-section-icon lin lin-location-pin"></i>
                <CarAutocomplete
                  id="pickup-select"
                  class="theme-search-area-section-input typeahead"
                  style="line-height: 48px !important;"
                  type="text"
                  placeholder="Retirada"
                  data-provide="typeahead"
                  v-validate="'required'"
                  v-model="pickup_location"
                  :dataInitial="pickupAutoCompleteDataInitial"
                />
              </div>
            </div>
          </div>
          <div class="col-md-2-5">
            <div
              class="theme-search-area-section theme-search-area-section-curved theme-search-area-section-fade-white"
            >
              <div class="theme-search-area-section-inner">
                <i class="theme-search-area-section-icon lin lin-location-pin"></i>
                <CarAutocomplete
                  id="delivery-select"
                  class="theme-search-area-section-input typeahead"
                  style="line-height: 48px !important;"
                  type="text"
                  placeholder="Devolução"
                  data-provide="typeahead"
                  v-model="delivery_location"
                  v-validate="'required'"
                  :dataInitial="deliveryAutoCompleteDataInitial"
                />
              </div>
            </div>
          </div>
          <div class="col-md-1-5">
            <div
              class="theme-search-area-section theme-search-area-section-curved theme-search-area-section-fade-white"
            >
              <div class="theme-search-area-section-inner">
                <i class="theme-search-area-section-icon lin lin-calendar"></i>
                <date-range-picker
                    v-model="start_date"
                    style="padding: 4px 0px 0px 40px !important;"
                    v-validate="'required'"
                    :singlePick="true"
                    :timePick="false"
                    :init="init_start_date"
                    :placeholder="'Retirada'"
                    ref="rangedate">
                </date-range-picker>
              </div>
            </div>
          </div>
          <div class="col-md-1-5">
            <div
              class="theme-search-area-section theme-search-area-section-curved theme-search-area-section-fade-white"
            >
              <div class="theme-search-area-section-inner">
                <i class="theme-search-area-section-icon lin lin-clock"></i>
                <select class="theme-search-area-section-input form-control" v-model="start_time">
                  <option :value="duration" v-for="(duration, index) in availableTime" :key="`${duration}-${index}`">
                    {{ duration }}
                  </option>
                </select>
              </div>
            </div>
          </div>

          <div class="col-md-1-5">
            <div
              class="theme-search-area-section theme-search-area-section-curved theme-search-area-section-fade-white"
            >
              <div class="theme-search-area-section-inner">
                <i class="theme-search-area-section-icon lin lin-calendar"></i>
                <date-range-picker
                    v-model="end_date"
                    style="padding: 4px 0px 0px 40px !important;"
                    v-validate="'required'"
                    :singlePick="true"
                    :timePick="false"
                    :minDate="minDate"
                    :init="init_end_date"
                    ref="rangedate"
                    :placeholder="'Devolução'"
                ></date-range-picker>
              </div>
            </div>
          </div>
          <div class="col-md-1-5">
            <div
              class="theme-search-area-section theme-search-area-section-curved theme-search-area-section-fade-white"
            >
              <div class="theme-search-area-section-inner">
                <i class="theme-search-area-section-icon lin lin-clock"></i>
                <select class="theme-search-area-section-input form-control" v-model="end_time">
                  <option :value="duration" v-for="(duration, index) in availableTime" :key="`${duration}-${index}`">
                    {{ duration }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="col-md-1">
            <button
              class="theme-search-area-submit _mt-0 theme-search-area-submit-no-border theme-search-area-submit-curved theme-search-area-submit-primary"
            >
              <i class="fa fa-search" aria-hidden="true"></i>
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import * as Moment from "moment";
import CarAutocomplete from "./fields/cars/CarAutocomplete.vue";
import DateRangePicker from "./fields/DateRangePicker.vue";
import { extendMoment } from 'moment-range';


const moment = extendMoment(Moment);
const DATE_BR_FORMAT = "DD/MM/YYYY HH:mm";
const DATE_ISO_8601 = "YYYY-MM-DD.HH:mm";

export default {
  components: {
    CarAutocomplete,
    DateRangePicker
  },
  data() {
    return {
      pickupAutoCompleteDataInitial: [],
      deliveryAutoCompleteDataInitial: [],
      pickup_location: null,
      delivery_location: null,
      init_start_date: {},
      init_end_date: {},
      start_date: null,
      end_date: null,
      start_time: '11:00',
      end_time: '11:00',
      minDate: null,
      submitted: false,
      availableTime: [],
      isBootstrapping: false
    };
  },
  beforeMount() {
    let params = this.$route.params;

    if (!Object.keys(params).length) return false;

    this.init_start_date = {
      startDate: params.datetime_start,
      endDate: params.datetime_start,
    };

    this.init_end_date = {
      startDate: params.datetime_end,
      endDate: params.datetime_end
    };

    if (!this.pickup_location) {
      this.isBootstrapping = true;
      this._fillAutoComplete();
      this.isBootstrapping = false;
    }

    if(this.$route.params) {
      this.start_time = new moment(this.$route.params.datetime_start).format('HH:mm');
      this.end_time = new moment(this.$route.params.datetime_end).format('HH:mm');
    }
  },
  mounted() {
    this.populateAvailableTime();
  },
  created (){
    this.$ga.page('/')
  },
  watch: {
    pickup_location(newVal, oldVal) {
      if (this.isBootstrapping) return;
      const deliveryId = this.delivery_location && this.delivery_location.id;
      const oldPickupId = oldVal && oldVal.id;
      if (!deliveryId || (oldPickupId && deliveryId === oldPickupId)) {
        this._fillAutoComplete({ delivery_location: newVal });
      }
    },
  },
  methods: {
    populateAvailableTime() {
      let availableTime = [];
      for (let hour = 0; hour < 24; hour++) {
        for (let minutes = 0; minutes < 60; minutes += 30) {
          let formattedHour = hour.toString().padStart(2, '0');
          let formattedMinutes = minutes.toString().padStart(2, '0');
          availableTime.push(`${formattedHour}:${formattedMinutes}`);
        }
      }
      this.availableTime = availableTime;
    },
    createInitialData(location) {
      let el;
      let text;
      let obj_id;
      if (typeof location === 'object') {
        el = location.el ? location.el : location;
        text = location.text || el.description;
        obj_id = location.id || el.place_id;
      } else {
        try {
          el = JSON.parse(location);
        } catch (e) {
          el = { description: String(location) };
        }
        text = el.description;
        obj_id = el.place_id;
      }
      return [
        {
          text: text,
          id: obj_id,
          el: el,
          value: text,
          data: {
            opening_times: JSON.parse(localStorage.getItem('vehicle::availableTime'))
          }
        }
      ];
    },
    _fillAutoComplete(params) {
      if(!params){
        params = this.$route.params;
      }
      if (params?.startDate && params?.endDate) {
        this.init_start_date = {
          startDate: params.startDate.format(DATE_ISO_8601)
        };
        this.init_end_date = {
          startDate: params.endDate.format(DATE_ISO_8601)
        };
      }

      if (!Object.keys(params).length) return false;

      if (params.pickup_location) {
        this.pickupAutoCompleteDataInitial = this.createInitialData(params.pickup_location);
        this.pickup_location = this.pickupAutoCompleteDataInitial[0];
      }
      if (params.delivery_location) {
        this.deliveryAutoCompleteDataInitial = this.createInitialData(params.delivery_location);
        this.delivery_location = this.deliveryAutoCompleteDataInitial[0];
      }
    },
    dateBR28901(date) {
      return moment(date, DATE_BR_FORMAT).format(DATE_ISO_8601);
    },
    submit(e) {
      this.$nextTick(() => {
        let datetime_start = this.dateBR28901(`${this.start_date.dateStart} ${this.start_time}`);
        let datetime_end = this.dateBR28901(`${this.end_date.dateStart} ${this.end_time}`);

        let pickup_location = JSON.stringify(this.pickup_location.el).replaceAll("/", "-")
        let delivery_location = JSON.stringify(this.delivery_location.el).replaceAll("/", "-")

        let url = `/cars/search/${pickup_location}/${delivery_location}/${datetime_start}/${datetime_end}/`
        this.$router.push(url);
      });
    },
    search_car(e) {
      e.preventDefault();
      this.$validator.validate().then(valid => {
        this.submitted = true;
        if (valid) {
          this.submit(e);
        } else {
          this.$swal({
            title: "Favor verificar os campos de busca",
            type: "error",
            confirmButtonText: "SAIR"
          });
        }
      });
    }
  }
};
</script>
